import { render, staticRenderFns } from "./FollowUpOrder.vue?vue&type=template&id=b69da3b4"
import script from "./FollowUpOrder.vue?vue&type=script&lang=js"
export * from "./FollowUpOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports